import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { URLS } from '../config/url';

const RegistrationPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    fatherName: '',
    grandFatherName: '',
    sex: '',
    educationLevel: '',
    dateOfBirth: '',
    region: '',
    city: '',
    fieldOfInterest: '',
    programType: '',
    contactPersonName: '',
    contactPersonPhone: '',
    essayFile: null,
    email: '',
    phone: '',
    leetcodeUsername: '',
    githubUsername: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const regions = ["Addis Ababa",
    "Afar",
    "Amhara",
    "Benishangul-Gumuz",
    "Dire Dawa",
    "Gambela",
    "Harari",
    "Oromia",
    "Sidama",
    "Somali",
    "South Ethiopia",
    "South West Ethiopia Peoples",
    "Southern Nations Nationalities (SNN)",
    "Tigray"];

  const citiesByRegion = {
    "Addis Ababa": ["Addis Ababa"],
    "Dire Dawa": ["Dire Dawa"],
    "Oromia": ["Adama",
      "Adola Town",
      "Agaro",
      "Ambo, Ethiopia",
      "Asella",
      "Babile (town)",
      "Bako, Oromia",
      "Bale Robe",
      "Bishoftu",
      "Bule Hora (town)",
      "Bule Hora",
      "Burayu",
      "Chinaksen",
      "Chiro",
      "Dader",
      "Dembidolo",
      "Dukem",
      "Durba",
      "Fiche",
      "Galan (town)",
      "Gimbi",
      "Goba",
      "Gore, Ethiopia",
      "Guder",
      "Gutin",
      "Haramaya",
      "Jimma",
      "Koye Feche",
      "Kulubi",
      "Meki",
      "Metu",
      "Moyale",
      "Naqamte",
      "Negele Arsi",
      "Negele Borana",
      "Sabata",
      "Sagure",
      "Sebeta Hawas (town)",
      "Shambu",
      "Shashamane",
      "Tijo",
      "Tulu Bolo",
      "Waliso", "Other"],
    "Tigray": ["Mekele", "Adigrat", "Axum", "Shire", "Adwa", "Humera", "Wukro", "Other"],
    "Amhara": ["Abomsa",
      "Addiet Canna",
      "Adis Zemen",
      "Bahir Dar",
      "Bati",
      "Bichena",
      "Bure",
      "Dabat",
      "Debark'",
      "Debre Birhan",
      "Debre Mark'os",
      "Debre Sina",
      "Debre Tabor",
      "Debre Werk'",
      "Dejen",
      "Dese",
      "Finote Selam",
      "Gondar",
      "Kemise",
      "Kombolcha",
      "Lalibela",
      "Robit",
      "Were Ilu",
      "Werota"],
    "Somali": ["Jijiga", "Gode", "Dolo Odo", "Kebri Dahar", "Danan", "Gursum", "Other"],
    "Southern Nations Nationalities (SNN)": ["Hawassa", "Dila", "Arba Minch", "Sodo", "Yirgalem", "Wendo Genet", "Other"],
    "South Ethiopia": ["Gedeo",
      "Gamo",
      "Gofa",
      "Konso",
      "South Omo",
      "Wolayita"],
    "South West Ethiopia Peoples": ["Bench Sheko",
      "Dawuro",
      "Kaffa",
      "Sheka",
      "West Omo"],
    "Afar": ["Semera", "Asaita", "Assab", "Bure", "Awash", "Dubti", "Other"],
    "Benishangul-Gumuz": ["Assosa", "Mendi", "Gilgel Beles", "Kurmuk", "Shambo", "Mao Komo", "Other"],
    "Gambela": ["Gambela", "Itang", "Abobo", "Jor", "Akobo", "Gog", "Other"],
    "Harari": ["Harar"],
    "Sidama": ["Hawassa", "Yirgalem", "Aleta Wendo", "Boricha", "Bensa", "Dilla", "Other"],
  };

  const interestOptions = {
    'Cyber & Security': [
      'Cybersecurity',
      'Pen Testing',
      'Network Defense',
      'Cryptography',
      'Incident Response',
      'Threat Intelligence',
      'Forensic Analysis',
      'Malware Development',
      'Vulnerability Assessment',
      "Other Cyber Fields"
    ],
    'Software Development': [
      'Frontend',
      'Backend',
      'Full Stack',
      'Mobile Development',
      'DevOps',
      'Cloud Architecture',
      'Database Management',
      "Other Software Fields"
    ],
    'Embedded & Hardware': [
      'IoT',
      'Embedded Systems',
      'Microcontrollers',
      'Firmware Development',
      'Robotics',
      'Sensor Integration',
      'Hardware Design',
      "Other Embedded Fields"

    ],
    'Aerospace': [
      'Aeronautics',
      'Propulsion Systems',
      'Avionics',
      'Spacecraft Design',
      'Aerodynamics',
      'Satellite Systems',
      'Flight Control Systems',
      'Space Robotics',
      'Satellite Communication',
      "Other Aerospace Fields"
    ]
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      'firstName', 'fatherName', 'grandFatherName', 'sex',
      'educationLevel', 'dateOfBirth', 'region', 'city',
      'fieldOfInterest', 'programType', 'contactPersonName', 'contactPersonPhone',
      'email', 'phone'
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = 'Required';
      }
    });

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    const fullPhone = `+251${formData.phone}`;
    const phoneRegex = /^\+251[97]\d{8}$/;
    if (formData.phone && !phoneRegex.test(fullPhone)) {
      newErrors.phone = 'Phone must start with +2519/7 and have 12 digits';
    }

    if (!formData.essayFile) {
      newErrors.essayFile = 'File required';
    }

    // Validate programType - only Weekend and Online are available
    const availableProgramTypes = ['Weekend', 'Online'];
    if (!formData.programType) {
      newErrors.programType = 'Program type is required';
    } else if (!availableProgramTypes.includes(formData.programType)) {
      newErrors.programType = `Only ${availableProgramTypes.join(' and ')} are currently available`;
    }

    // Validate contact person name
    if (!formData.contactPersonName || formData.contactPersonName.trim().length === 0) {
      newErrors.contactPersonName = 'Contact person name is required';
    }

    // Validate contact person phone
    if (!formData.contactPersonPhone || formData.contactPersonPhone.trim().length === 0) {
      newErrors.contactPersonPhone = 'Contact person phone is required';
    } else {
      const fullContactPhone = formData.contactPersonPhone.startsWith('+251') 
        ? formData.contactPersonPhone 
        : `+251${formData.contactPersonPhone}`;
      const phoneRegex = /^\+251[97]\d{8}$/;
      if (!phoneRegex.test(fullContactPhone)) {
        newErrors.contactPersonPhone = 'Phone must start with +2519/7 and have 12 digits';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, size } = e.target;
    if (e && size > 5 * 1024 * 1024) {
      alert("File size must be less than 5MB.");
      e.target.value = null;
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlerFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, essayFile: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      try {
        const formDataToSend = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
          // Format contact person phone if it doesn't start with +251
          if (key === 'contactPersonPhone' && value && !value.startsWith('+251')) {
            formDataToSend.append(key, `+251${value}`);
          } else {
            formDataToSend.append(key, value);
          }
        });

        const response = await axios.post(`${URLS}/api/register`, formDataToSend, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response.status === 200 || response.status === 201) {
          setShowPopup(true);
        }
      } catch (error) {
        setErrors({ api: 'Failed to submit registration. Please try again.' });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex justify-center items-center p-4 md:p-6">
      <div className="bg-white rounded-xl shadow-xl p-6 md:p-10 w-full max-w-4xl space-y-8 relative">
        {/* Page Title */}
        <h1 className="text-3xl font-bold text-[#1976d2]">Register</h1>
        {errors.api && <p className="text-red-500 text-center">{errors.api}</p>}

        {/* Program Type Selection - Cards */}
        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-4 text-gray-700">Select Program Type *</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <button
              type="button"
              onClick={() => setFormData(prev => ({ ...prev, programType: 'Weekend' }))}
              disabled={isSubmitting}
              className={`p-6 rounded-xl border-2 transition-all duration-300 text-left ${
                formData.programType === 'Weekend'
                  ? 'border-[#1976d2] bg-blue-50 shadow-md'
                  : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'
              } ${isSubmitting ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Weekend Program</h3>
                  <p className="text-gray-600 text-sm">Attend classes on weekends</p>
                </div>
                {formData.programType === 'Weekend' && (
                  <div className="w-6 h-6 rounded-full bg-[#1976d2] flex items-center justify-center">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                )}
              </div>
            </button>

            <button
              type="button"
              onClick={() => setFormData(prev => ({ ...prev, programType: 'Online' }))}
              disabled={isSubmitting}
              className={`p-6 rounded-xl border-2 transition-all duration-300 text-left ${
                formData.programType === 'Online'
                  ? 'border-[#1976d2] bg-blue-50 shadow-md'
                  : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'
              } ${isSubmitting ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Online Program</h3>
                  <p className="text-gray-600 text-sm">Learn from anywhere, anytime</p>
                </div>
                {formData.programType === 'Online' && (
                  <div className="w-6 h-6 rounded-full bg-[#1976d2] flex items-center justify-center">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                )}
              </div>
            </button>
          </div>
          {errors.programType && <p className="text-red-500 text-sm mt-2">{errors.programType}</p>}
        </section>

        {/* Download Essay Format Section */}
        <section className="flex flex-col md:flex-row items-center justify-between bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 shadow-sm">

          <div className="md:w-2/3">
            <h2 className="text-2xl font-bold text-blue-700 mb-3">Registration Template</h2>
            <p className="text-gray-700 mb-5">
              Please download the registration essay template document, complete it, and upload it in the <strong>Upload</strong> section below.
            </p>

            <a
              href="./storage/CTE.docx"
              download="Essay_Format.docx"
              className="mt-5 inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-5 rounded-md transition duration-300"
            >
              Download Essay Format
            </a>
          </div>
          <div className="mt-6 md:mt-0 md:w-1/3 flex justify-center">
            <img
              src="./images/doc.png"
              alt="Word Document Icon"
              className="w-20 h-20 opacity-80"
            />
          </div>
        </section>


        {/* Personal Info */}
        <section className="bg-gray-50 rounded-lg p-4 md:p-6">
          <h2 className="text-xl font-semibold mb-6 text-gray-800">Personal Information</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
            {['firstName', 'fatherName', 'grandFatherName'].map((field) => (
              <div key={field}>
                <input
                  type="text"
                  name={field}
                  placeholder={field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                  value={formData[field]}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
                  disabled={isSubmitting}
                />
                {errors[field] && <p className="text-red-500 text-sm">{errors[field]}</p>}
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
            <div>
              <label htmlFor="sex" className="block text-sm font-medium text-gray-700 mb-1">
                Gender
              </label>
              <select 
                id="sex"
                name="sex" 
                value={formData.sex} 
                onChange={handleChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
                disabled={isSubmitting}>
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              {errors.sex && <p className="text-red-500 text-sm mt-1">{errors.sex}</p>}
            </div>

            <div>
              <label htmlFor="educationLevel" className="block text-sm font-medium text-gray-700 mb-1">
                Education Level
              </label>
              <select 
                id="educationLevel"
                name="educationLevel" 
                value={formData.educationLevel} 
                onChange={handleChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
                disabled={isSubmitting}>
                <option value="">Select Education Level</option>
                <option value="primary">Primary</option>
                <option value="high-school">High School</option>
                <option value="university-undergraduate">Undergraduate</option>
                <option value="graduate">Graduate</option>
              </select>
              {errors.educationLevel && <p className="text-red-500 text-sm mt-1">{errors.educationLevel}</p>}
            </div>

            <div>
              <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700 mb-1">
                Date of Birth
              </label>
              <input
                type="date"
                id="dateOfBirth"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
                disabled={isSubmitting}
              />
              {errors.dateOfBirth && <p className="text-red-500 text-sm mt-1">{errors.dateOfBirth}</p>}
            </div>
          </div>
        </section>

        {/* Location Info */}
        <section className="bg-gray-50 rounded-lg p-4 md:p-6">
          <h2 className="text-xl font-semibold mb-6 text-gray-800">Location & Interests</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <select name="region" value={formData.region} onChange={handleChange}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
              disabled={isSubmitting}>
              <option value="">Select Region</option>
              {regions.map(region => <option key={region} value={region}>{region}</option>)}
            </select>

            <select name="city" value={formData.city} onChange={handleChange} disabled={!formData.region || isSubmitting}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition">
              <option value="">Select City</option>
              {formData.region &&
                citiesByRegion[formData.region].map(city => (
                  <option key={city} value={city}>{city}</option>
                ))}
            </select>

            <select name="fieldOfInterest" value={formData.fieldOfInterest} onChange={handleChange}
              className="w-full col-span-2 px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
              disabled={isSubmitting}>
              <option value="">Select Field of Interest</option>
              {Object.entries(interestOptions).map(([group, options]) => (
                <optgroup key={group} label={group}>
                  {options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                </optgroup>
              ))}
            </select>
          </div>
        </section>

        {/* Contact Person Info */}
        <section className="bg-gray-50 rounded-lg p-4 md:p-6">
          <h2 className="text-xl font-semibold mb-6 text-gray-800">Contact Person</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl">
            <div>
              <input
                type="text"
                name="contactPersonName"
                placeholder="Contact Person Name *"
                value={formData.contactPersonName}
                onChange={handleChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
                disabled={isSubmitting}
              />
              {errors.contactPersonName && <p className="text-red-500 text-sm mt-1">{errors.contactPersonName}</p>}
            </div>

            <div>
              <div className="flex">
                <span className="bg-gray-200 px-4 py-2.5 rounded-l-lg border border-gray-300 border-r-0 text-gray-700">+251</span>
                <input
                  type="tel"
                  name="contactPersonPhone"
                  placeholder="Phone Number *"
                  value={formData.contactPersonPhone}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
                  disabled={isSubmitting}
                />
              </div>
              {errors.contactPersonPhone && <p className="text-red-500 text-sm mt-1">{errors.contactPersonPhone}</p>}
            </div>
          </div>
        </section>

        {/* Upload + Contact */}
        <section className="bg-gray-50 rounded-lg p-4 md:p-6">
          <h2 className="text-xl font-semibold mb-6 text-gray-800">Upload & Contact</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="essayFile" className="block mb-2 font-medium text-gray-700">Select the filled form *</label>
              <div className="flex flex-row items-center gap-4">
                <label
                  htmlFor="essayFile"
                  className="bg-[#1976d2] hover:bg-[#125cb3] text-white font-semibold py-2.5 px-5 rounded-lg cursor-pointer transition duration-300 disabled:bg-gray-400 shadow-sm"
                >
                  Upload Form
                </label>
                <input
                  type="file"
                  id="essayFile"
                  accept=".docx, .pdf"
                  onChange={handlerFileChange}
                  className="hidden"
                  disabled={isSubmitting}
                />
                {formData.essayFile && <p className="text-sm text-gray-600">Selected: {formData.essayFile.name}</p>}
              </div>
              {errors.essayFile && <p className="text-red-500 text-sm mt-1">{errors.essayFile}</p>}
            </div>

            <div>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
                disabled={isSubmitting}
              />
              {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
            </div>

            <div className="flex">
              <span className="bg-gray-200 px-4 py-2.5 rounded-l-lg border border-gray-300 border-r-0 text-gray-700">+251</span>
              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
                disabled={isSubmitting}
              />
            </div>
            {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
            <div className="flex flex-col md:flex-row w-full">
              <span className="bg-gray-200 px-4 py-2.5 rounded-t-lg md:rounded-l-lg md:rounded-tr-none border border-gray-300 border-b-0 md:border-b border-r-0 text-gray-700 text-sm">
                https://leetcode.com/u/
              </span>
              <input
                type="text"
                name="leetcodeUsername"
                placeholder="(Optional)"
                value={formData.leetcodeUsername}
                onChange={handleChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-b-lg md:rounded-r-lg md:rounded-bl-none focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
                disabled={isSubmitting}
              />
            </div>

            <div className="flex flex-col md:flex-row w-full">
              <span className="bg-gray-200 px-4 py-2.5 rounded-t-lg md:rounded-l-lg md:rounded-tr-none border border-gray-300 border-b-0 md:border-b border-r-0 text-gray-700 text-sm">
                https://github.com/
              </span>
              <input
                type="text"
                name="githubUsername"
                placeholder="(Optional)"
                value={formData.githubUsername}
                onChange={handleChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-b-lg md:rounded-r-lg md:rounded-bl-none focus:ring-2 focus:ring-[#1976d2] focus:border-[#1976d2] transition"
                disabled={isSubmitting}
              />
            </div>


          </div>
        </section>

        <button
          type="submit"
          onClick={handleSubmit}
          className="w-full bg-[#1976d2] hover:bg-[#125cb3] text-white font-semibold py-3 rounded-lg transition duration-300 disabled:bg-gray-400"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>

        {/* Success Popup */}
        {showPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-8 max-w-md w-full shadow-2xl animate-bounce-in">
              <h2 className="text-2xl font-bold text-[#1976d2] mb-4"> Registration Successful!</h2>
              <p className="text-gray-600 mb-6">
                Your registration has been successfully submitted. You will receive a confirmation email shortly.
              </p>
              <button
                onClick={handleClosePopup}
                className="w-full bg-[#1976d2] hover:bg-[#125cb3] text-white font-semibold py-2 rounded-lg transition duration-300"
              >
                Back to Home
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// Custom animation for popup
const styles = `
  @keyframes bounce-in {
    0% {
      transform: scale(0.3);
      opacity: 0;
    }
    50% {
      transform: scale(1.05);
      opacity: 1;
    }
    100% {
      transform: scale(1);
    }
  }

  .animate-bounce-in {
    animation: bounce-in 0.5s ease;
  }
`;

const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default RegistrationPage;